import accountreconciliationFullcont from './accountreconciliation-fullcont.html'

const dialog                    = require('../../../../../components/dialog/dialog')
const fullcontEntity            = require('../../../../../components/fullcont/fullcont-entity')
const fullcontHandler           = require('../../../../../components/fullcont/fullcont-handler')
const dtGenerator               = require('../../../../../components/dt/dt-generator')
const dbRequest                 = require('../../../../../js-network/db-request')
const websocket                 = require('../../../../../js-network/web-socket')
const reconciliationDt          = require('./accountreconciliation-dt')
const transactionDt             = require('../transaction/transaction-dt')
const reconciliationDialog      = require('./accountreconciliation-dialog')
const handler                   = require('./accountreconciliation-fullcont-handler')
const {form, formCopy}          = require('./accountreconciliation-fullcont-form')
const {accountreconciliationMT} = require('./accountreconciliation-fullcont-multitable')

var htmlFc          = {}
var HTMLwasSelected = false
var deleting        = false

function HTMLselect() {
      fullcontHandler.HTMLselect(
            'accountreconciliation',
            'accountreconciliation',
            'accountreconciliation-fullcont',
            accountreconciliationFullcont, form, formCopy, accountreconciliationMT,
            editDialog, deleteDialog, dtCall, htmlFc)
      HTMLwasSelected = true
}

export function start(detail) {
      if (!HTMLwasSelected) HTMLselect()
      obj[detail.act].start(detail)
}

const obj = {
      prepareAdd:       { start: (detail)=>{ fullcontEntity.prepareAdd(detail, htmlFc, handler.setDefaultValue)                        }},
      addOne:           { start: (detail)=>{ save(detail, 'addOne')                                                                    }},
      update:           { start: (detail)=>{ save(detail, 'update')                                                                    }},
      saveFromDialog:   { start: (detail)=>{ save(detail, htmlFc.fullcontHTML.classList.contains('mode-add') ? 'addOne' : 'update')    }},
      selectOne:        { start: (detail)=>{ selectOne(detail)                                                                         }},
      selectOneNoCheck: { start: (detail)=>{ handler.cancelLoad(htmlFc); fullcontEntity.selectOneNoCheck(detail, htmlFc, afterProcess) }},
      prepareEdit:      { start: (detail)=>{ prepareEdit(detail)                                                                       }},
      cancelEdit:       { start: (detail)=>{ cancelEdit(detail)                                                                        }},
      hide:             { start: (detail)=>{ if (fullcontEntity.hide(detail, htmlFc)) handler.cancelLoad(htmlFc)                       }},
      discard:          { start: (detail)=>{ handler.cancelLoad(htmlFc); fullcontHandler.discard(detail, htmlFc)                       }},
      getTransactions:  { start: (detail)=>{ handler.getTransactions(detail, htmlFc)                                                   }},
      deleteEntity:     { start: (detail)=>{ fullcontEntity.deleteEntity(detail, htmlFc)                                               }},
      deleteFromDialog: { start: (detail)=>{ deleteFromDialog(detail)                                                                  }},
}

function editDialog() {
      dialog.start({ act: 'show', id: 'saveChanges', entity: 'accountreconciliation' })
}

function deleteDialog(detail) {
      reconciliationDialog.confirmDelete(detail)
}

function dtCall(act, result) {
      if (document.getElementById('accountreconciliation-dt')) {
            reconciliationDt.start({ act, row: result })
      }
}

// Los registros cargados conservan sus checks; al editar se agregan los pendientes actuales.
function prepareEdit(detail) {
      if (htmlFc.fullcontHTML.classList.contains('mode-edit') || htmlFc.fullcontHTML.classList.contains('mode-add')) return
      fullcontHandler.prepareEdit(detail, htmlFc)
      if (htmlFc.fullcontHTML.classList.contains('mode-edit')) handler.getTransactions(detail, htmlFc)
}

function selectOne(detail) {
      if (fullcontEntity.selectOne(detail, htmlFc, afterProcess)) handler.cancelLoad(htmlFc)
}

function cancelEdit(detail) {
      if (!fullcontEntity.cancelEdit(detail, htmlFc)) return
      handler.cancelLoad(htmlFc)
      fullcontEntity.selectOneNoCheck({
            ...detail,
            dbid: htmlFc.fullcontHTML.getAttribute('data-dbid'),
      }, htmlFc, afterProcess)
}

function save(detail, action) {
      const mode = action === 'addOne' ? 'mode-add' : 'mode-edit'
      if (!htmlFc.fullcontHTML.classList.contains(mode) || !handler.verifyMultitable(detail, htmlFc)) return
      fullcontEntity[action](detail, htmlFc, afterProcess)
}

function afterProcess(data, result) {
      if (result.restriction && result.restriction.val !== 'ok') return
      handler.cancelLoad(htmlFc)
      handler.rememberSelection(htmlFc)
      refreshTransactions()
}

// El endpoint sigue siendo delete.php. Se comprueba la respuesta antes de animar o cerrar.
async function deleteFromDialog(detail) {
      if (deleting) return
      deleting = true
      try {
            const result = await dbRequest.start({
                  inf: {
                        entity: 'accountreconciliation',
                        ids: JSON.stringify(detail.dbid),
                  }
            }, 'server/php/sql/delete.php')
            if (result.status !== 'ok' || result.restriction?.val !== 'ok') {
                  throw new Error(result.extrainfo?.message || 'The reconciliation could not be deleted.')
            }
            const current = htmlFc.fullcontHTML.getAttribute('data-dbid')
            if (detail.dbid.map(String).includes(current)) {
                  handler.cancelLoad(htmlFc)
                  fullcontHandler.discard({ dest: 'accountreconciliation', id: 'accountreconciliation-fullcont' }, htmlFc)
            }
            dtGenerator.deleteRow({ dest: 'accountreconciliation', dbid: detail.dbid })
            websocket.entityUpdate('entityUpdate', 'deleteRow', {
                  ...detail,
                  dest: 'accountreconciliation',
                  entity: 'accountreconciliation',
            }, { to: 'allStaff', from: 'staffDesktop', id: '' })
            setTimeout(() => reconciliationDt.start({ act: 'refresh' }), 900)
            refreshTransactions()
      } catch (error) {
            setTimeout(() => reconciliationDialog.message(error.message || 'The reconciliation could not be deleted.'), 350)
      } finally {
            deleting = false
      }
}

function refreshTransactions() {
      if (document.getElementById('transaction-dt')) transactionDt.start({ act: 'refresh', dest: 'transaction' })
}
